import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { apiGet } from '../../lib/api';
import { useAuth } from '../../contexts/AuthContext';
import { canRunInspection } from '../../pages/stores/stores-constants';
import { GRNDetailModal } from './GRNDetailModal';

/** GRN fix #9 — opens the shared GRN detail + InspectionForm from the Quality module. */
export function GRNInspectDialog({ grnId, onClose, onInspected }) {
  const { user } = useAuth();
  const [grn, setGrn] = useState(null);
  useEffect(() => {
    apiGet(`/stores/grn/${grnId}`).then(setGrn).catch(() => { toast.error('Could not load the GRN'); onClose(); });
  }, [grnId, onClose]);
  if (!grn) return null;
  return (
    <GRNDetailModal grn={grn} canInspect={canRunInspection(user)} currentUser={user} onClose={onClose}
      onInspected={() => { onInspected?.(); onClose(); }} />
  );
}
